import { render, staticRenderFns } from "./e-overlay-block.vue?vue&type=template&id=215af8c8&lang=pug&"
import script from "./e-overlay-block.vue?vue&type=script&lang=js&"
export * from "./e-overlay-block.vue?vue&type=script&lang=js&"
import style0 from "./e-overlay-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VOverlay,VRow})
